module.exports = __webpack_public_path__ + "img/prize-05.2332158d.png";